<curr-logo class="logo"></curr-logo>
<div class="static-page-title">CURRICULUM LIMITED - TERMS OF USE</div>
<curr-terms-of-use-content></curr-terms-of-use-content>
